import { createTheme as createDSTheme } from 'app/shopify';
import { View } from 'react-native';

const theme = createDSTheme();

export function LandingPageSectionSeparator() {
  return <View style={{ height: theme.spacing['spacing.general.x5'] }} />;
}
